import { SvgIcon, SvgIconProps } from '@material-ui/core';
import { RUSTFS_PATHS } from './paths';

/** RustFS: ведро — объектное хранилище S3 кластеров на хостах. */
export const RustfsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    {RUSTFS_PATHS.map(d => (
      <path key={d} d={d} />
    ))}
  </SvgIcon>
);
